// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance from "../../../api/adminAxiosInstance";
import { endpoints } from "../../../api/endpoints";

export const OfferDeclineApi = createAsyncThunk(
  "AdminPayout/OfferDeclineApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.getofferdeclinedlist,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const OfferDeclineApiSlice = createSlice({
  name: "OfferDeclineApiSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(OfferDeclineApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(OfferDeclineApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(OfferDeclineApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default OfferDeclineApiSlice.reducer;
